import client from "../client";

export interface RPSCreatedRoomRequest {
  bet_result_id?: number;
  bet_id?: number;
}

export default function API(request: RPSCreatedRoomRequest): Promise<any> {
  return client
    .post(`gameinhouse/rps/rps_created_room`, request)
    .then((response) => response.data);
}
